module.exports = __webpack_public_path__ + "img/dept-8.7817cf8e.svg";